module.exports = __webpack_public_path__ + "static/media/waves.a2b37daf.svg";